import ReactDOM from "react-dom";
import React, { Component } from "react";
import WaterGraph from "./WaterGraph/index";

const init = () => {
  const container = document.getElementById("water-data");
  const url = window.location.href.split("/");
  const slug = url[url.length - 1];

  // (logic copied from old profile.blade.php, not really scalable if more sites have water
  // -- but for some reason the IDs on the watergraph are hardcoded to tallebudgera's anyway)
  if (container && slug === "tallebudgera-state-school") {
    ReactDOM.render(<WaterGraph />, container);
  }
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/waterGraph.js